/* unplugin-vue-components disabled */import { render } from "./noData.vue?vue&type=template&id=cc191f4a&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"

import "./noData.vue?vue&type=style&index=0&id=cc191f4a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc191f4a"]])

export default __exports__